module.exports = __webpack_public_path__ + "static/media/link-alt.118e8fc6.svg";